export interface PdfEditorConfig {
  key: string;
  value: any;
}
